import { useEffect } from "react";
import LOGO from "../../assets/logo.png";
import Button from "../../componentes/button/button";
import { useApp } from "../../context/appContext";

export default function SelecionarAplicativo() {
    const { aplicativosPermitidos, trocarAplicativo } = useApp();

    useEffect(() => {
        document.title = "MyDash | Selecionar Aplicativo";
    }, []);

    return (
        <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4 py-12">
            <div className="flex flex-col items-center text-center mb-10">
                <img src={LOGO} alt="Logo Mydash" className="h-10 w-auto object-contain mb-4" />
                <p className="text-muted-foreground">Selecione o aplicativo que deseja acessar</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full max-w-3xl">
                {aplicativosPermitidos.map(app => (
                    <div
                        key={app.key}
                        className="bg-card border border-border rounded-2xl shadow-card p-8 flex flex-col items-center text-center gap-3 hover:shadow-pop hover:-translate-y-1 transition-all duration-200"
                    >
                        <div>
                            <img src={app.img} alt={`Logo ${app.nome}`} className="h-16 w-auto object-contain" />
                        </div>
                        <p className="text-sm text-muted-foreground min-h-[2.5rem] mt-4">{app.descricao}</p>
                        <Button
                            variant="blue"
                            label="Acessar"
                            iconLeft="fa fa-arrow-right"
                            onClick={() => trocarAplicativo(app.key)}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
